import { TooltipHorizontalOffset, TooltipVerticalOffset } from './types.js';

const DEFAULT_TOOLTIP_POSITION = {
  horizontal: TooltipHorizontalOffset.Center,
  vertical: TooltipVerticalOffset.Above
};
const TOOLTIP_POSITION_DEFAULT_RETURN = {
  x: 0,
  y: 0,
  position: DEFAULT_TOOLTIP_POSITION,
  activeIndex: null
};

export { DEFAULT_TOOLTIP_POSITION, TOOLTIP_POSITION_DEFAULT_RETURN };
